import * as React from "react"
interface SvgComponentProps {
	[key: string]: any;
}
const AiIcon: React.FC<SvgComponentProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="m8.764.004 1.749 4.022 1.464 1.464 4.022 1.749v1.527l-4.022 1.749-1.464 1.464L8.763 16H7.238l-1.75-4.022-1.463-1.464-4.022-1.75V7.24l4.022-1.75 1.464-1.463L7.237.004h1.527Zm7.616 12.029.796 1.83.963.963 1.83.796v.76l-1.83.796-.963.963-.796 1.83h-.76l-.796-1.83-.963-.963-1.83-.796v-.76l1.83-.796.963-.963.796-1.83h.76Z"
    />
  </svg>
)
export default AiIcon
